import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';

const SignInButton = ({ onClick, loading = false, user = null }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            onClick={onClick}
            loading={loading}
            disabled={loading}
            style={{
                backgroundColor: 'white',
                border: '1px solid #dadce0',
                borderRadius: '8px',
                padding: '10px 14px',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                maxWidth: '300px',
                boxShadow: isHovered && !loading 
                    ? '0 2px 8px rgba(0,0,0,0.15)' 
                    : '0 1px 3px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1
            }}
            onMouseEnter={() => !loading && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Left side - User info */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {/* User avatar */}
                <div style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    backgroundColor: user?.picture ? 'transparent' : '#f8f9fa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #e9ecef',
                    overflow: 'hidden'
                }}>
                    {user?.picture ? (
                        <img
                            src={user.picture}
                            alt="Profile"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                            referrerPolicy="no-referrer"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = `
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="2">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                `;
                            }}
                        />
                    ) : (
                        user?.name ? (
                            <span style={{ 
                                fontSize: '13px', 
                                fontWeight: 'bold', 
                                color: '#6c757d' 
                            }}>
                                {user.name.charAt(0).toUpperCase()}
                            </span>
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        )
                    )}
                </div>
                
                {/* User info text */}
                <div style={{ textAlign: 'left' }}>
                    <div style={{ 
                        fontSize: '14px', 
                        fontWeight: '500', 
                        color: '#3c4043',
                        lineHeight: '1.3'
                    }}>
                        {user ? `Sign in as ${user.name}` : 'Sign in with Google'}
                    </div>
                    <div style={{ 
                        fontSize: '12px', 
                        color: '#5f6368',
                        lineHeight: '1.3'
                    }}>
                        {user ? user.email : 'Use your CrashPlan account'}
                    </div>
                </div>
            </div>

            {/* Right side - Google logo */}
            <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                transform: isHovered && !loading ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.2s ease'
            }}>
                <svg width="18" height="18" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
            </div>
        </Button>
    );
};

export default SignInButton;